import { useRef, useDebugValue, useEffect } from 'react';

import { clog } from '@app/utils/clog';

function getDiff<T>(newProps: T, oldProps: T) {
  const changedProps: Array<keyof T> = [];

  for (const key in newProps) {
    if (newProps[key] !== oldProps[key]) {
      changedProps.push(key as keyof T);
    }
  }

  return changedProps;
}

export function useRenderTimes<T>(props: T) {
  const renderCount = useRef(0);
  const prevProps = useRef<T | null>(null);
  const changedProps = useRef<Array<keyof T>>([]);

  renderCount.current += 1;

  if (prevProps.current) {
    changedProps.current = getDiff(props, prevProps.current);
  }

  prevProps.current = props;

  useDebugValue({
    renderCount: renderCount.current,
    changedProps: changedProps.current,
  });

  useEffect(() => {
    clog('Render count:', renderCount.current);
    if (changedProps.current.length > 0) {
      clog('Changed props:', changedProps.current);
    }
  });
}
